import { Injectable } from '@angular/core';

export type CaregiverActivityStatus = 'tried' | 'completed' | 'skipped';

@Injectable({ providedIn: 'root' })
export class CaregiverActivityStore {
  private readonly namespace = 'learning-garden-caregiver-activity';

  get(profileId: string, activityId: string): CaregiverActivityStatus | null {
    const value = localStorage.getItem(this.key(profileId, activityId));
    return value === 'tried' || value === 'completed' || value === 'skipped' ? value : null;
  }

  set(profileId: string, activityId: string, status: CaregiverActivityStatus): void {
    localStorage.setItem(this.key(profileId, activityId), status);
  }

  removeForProfile(profileId: string): void {
    const prefix = `${this.namespace}:${profileId}:`;
    for (let index = localStorage.length - 1; index >= 0; index -= 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    }
  }

  private key(profileId: string, activityId: string): string {
    return `${this.namespace}:${profileId}:${activityId}`;
  }
}
